<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
      :handleRefresh="handleRefresh"
    />
    <section
      class="posire approveBoxPa"
      id="approveBoxPaContent"
      :style="`height: ${contentHeight || 'auto'}`"
    >
      <!-- 左侧列表 -->
      <ApproveList
        ref="approveList"
        @choose="handleApproveChoose"
        :isShow="isShow"
        :tabVal="tabVal"
        :handleRefresh="handleRefresh"
      />
      <!-- 左侧列表 end -->
      <!-- 右侧审核内容 -->
      <section class="rightSide">
        <component
          :is="componentName"
          :id="activeItem.busiId"
          :busiCode="activeItem.busiCode"
          :key="activeItem.busiId"
          :type="tabVal === '1' ? 'approve' : ''"
          :handleRefresh="handleRefresh"
        />
      </section>
      <!-- 右侧审核内容 end -->
    </section>
  </section>
</template>

<script>
import { getElementHeight } from '@qx/utils';
import {
  approveTypeList,
} from 'api';
import {
  mapState,
} from 'vuex';
import ApproveList from './approveList';
import CustomerArchives from 'views/manage/archives/customer/archives/detail/detail';
import CustomerLine from 'views/manage/archives/customer/line/detail/detail';
import DriverArchives from 'views/manage/archives/driver/archives/detail/detail';
import DriverInvited from 'views/manage/archives/driver/invited/detail/detail';
import CarMy from 'views/manage/car/archives/my/detail/detail';
import CarTrailer from 'views/manage/car/trailer/archives/detail/detail';
import CostBorrowManage from 'views/manage/cost/borrow/manage/detail/detail';
import CostCarApply from 'views/manage/cost/car/apply/costDetail/costDetail';
// import CostMaintenanceDetail from 'views/manage/cost/car/apply/maintenanceDetail/maintenanceDetail';
import CostCar from 'views/manage/cost/car/car/detail/detail';
import CostManage from 'views/manage/cost/manage/detail/detail';
import CostReport from 'views/manage/cost/report/approve/detail/detail';
import OrderApprove from 'views/manage/operate/order/approve/approvePage/approvePage';
import OrderDeal from 'views/manage/operate/order/deal/orderDetailTab/detail/detail';
// import OrderDealDriver from 'views/manage/operate/order/deal/orderDetailTab/driver/detail/detail';
import OrderDealUnusual from 'views/manage/operate/order/deal/orderDetailTab/unusual/detail/detail';
import ServiceMerchant from 'views/manage/service/merchant/manage/detail/detail';
import ServiceSiteSelf from 'views/manage/service/site/self/detail/detail';
import RiskMoney from 'views/manage/system/risk/money/money';
import OrderReceipt from 'views/manage/operate/order/receipt/approveDialog';
export default {
  components: {
    ApproveList,
    CustomerArchives, // 客户档案
    CustomerLine, // 客户线路
    DriverArchives, // 司机档案
    DriverInvited, // 司机 - 被邀请
    CarMy, // 车辆 - 自有
    CarTrailer, // 车辆 - 挂车
    CostBorrowManage, // 借支管理
    CostCarApply, // 车辆费用申请
    // CostMaintenanceDetail, // 维保费用申请
    CostCar, // 车辆费用
    CostManage, // 管理费用
    CostReport, // 上报费用
    OrderApprove, // 订单审核
    OrderDeal, // 订单处理
    OrderDealUnusual, // 异常订单
    ServiceMerchant, // 服务商
    ServiceSiteSelf, // 自有站点
    RiskMoney, // 资金风控
    OrderReceipt, // 回单审核
  },
  props: {
    tabVal: {
      type: String,
    },
    isShow: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
    componentName () {
      switch (this.activeItem.busiCode) {
        case '100000': // 客户档案
          return 'CustomerArchives';
        case '100001': // 客户线路
          return 'CustomerLine';
        case '100002': // 司机档案
          return 'DriverArchives';
        case '100011': // 司机 - 被邀请
          return 'DriverInvited';
        case '100005': // 车辆 - 自有
          return 'CarMy';
        case '100009': // 车辆 - 挂车
          return 'CarTrailer';
        case '21000023': // 司机借支
          return 'CostBorrowManage';
        case '21000022': // 员工借支
          return 'CostBorrowManage';
        case '22000048': // 车辆费用申请
          return 'CostCarApply';
        // case '22000048': // 维保费用申请
        //   return 'CostMaintenanceDetail';
        case '22000050': // 车辆费用
          return 'CostCar';
        case '22000023': // 管理费用
          return 'CostManage';
        case '22000022': // 上报费用
          return 'CostReport';
        case '300003': // 订单审核
        case '300002':
        case '300009':
          return 'OrderApprove';
        case '300004': // 失效审核
        case '300005': // 订单处理
          return 'OrderDeal';
        case '300001': // 异常订单
          return 'OrderDealUnusual';
        case '400000': // 服务商
          return 'ServiceMerchant';
        case '400001': // 自有站点
          return 'ServiceSiteSelf';
        case '100003': // 资金风控
          return 'RiskMoney';
        case '300008': // 回单审核
          return 'OrderReceipt';
        default:
          return 'span';
      }
    },
  },
  data () {
    return {
      contentHeight: 0,
      searchBoxData: {
        busiCodeOptions: [],
        form: [
          { // 申请日期
            label: '申请日期',
            value: 'ApplyDate',
            type: 'date',
            placeholder: '请选择申请日期',
            attr: {
              type: 'daterange',
            },
          },
          { // 申请人
            label: '申请人',
            value: 'applyUserName',
            type: 'input',
            placeholder: '请输入申请人',
            hide: this.tabVal === '2',
          },
          { // 类型
            label: '类型',
            value: 'busiCode',
            type: 'select',
            placeholder: '请选择类型',
          },
        ],
      },
      activeItem: {},
    };
  },
  methods: {
    sub (searchBoxData) {
      if (!!searchBoxData.ApplyDate && searchBoxData.ApplyDate[0]) {
        searchBoxData.startApplyDate = this.formatDate(searchBoxData.ApplyDate[0]);
        searchBoxData.endApplyDate = this.formatDate(searchBoxData.ApplyDate[1]);
      }
      delete searchBoxData.ApplyDate;
      const applyUserId = this.userInfo.staffTFInfo.userId;
      if (this.tabVal === '2' && !applyUserId) { // 刷新时候用户信息还没拿到，等一会
        setTimeout(() => {
          this.sub(searchBoxData);
        }, 1000);
      } else {
        this.$refs.approveList.getData({
          applyUserId: this.tabVal === '2' ? applyUserId : null,
          ...searchBoxData,
        });
      }
    },
    handleRefresh () {
      this.getApproveTypeList();
      let _data = {
        'applyUserName': null,
        'busiCode': null,
      };
      this.sub(_data);
    },
    handleApproveChoose (item) {
      this.activeItem = item;
    },
    getElementHeight () {
      this.contentHeight = getElementHeight('approveBoxPaContent');
    },
    async getApproveTypeList () {
      this.searchBoxData.busiCodeOptions = await approveTypeList();
    },
  },
  async created () {
    this.getApproveTypeList();
    // this.searchBoxData.busiCodeOptions = await approveTypeList();
  },
  mounted () {
    this.getElementHeight();
    window.addEventListener('resize', this.getElementHeight);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getElementHeight);
  },
};
</script>

<style scoped lang="scss">
.approveBoxPa {
  padding-left: 308px;
  .rightSide {
    // height: 1500px;
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #999;
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #e0e0e0;
    }
  }
}
</style>
